import { render, staticRenderFns } from "./CriteriaModal.vue?vue&type=template&id=4ba98eba&scoped=true&"
import script from "./CriteriaModal.vue?vue&type=script&lang=js&"
export * from "./CriteriaModal.vue?vue&type=script&lang=js&"
import style0 from "./CriteriaModal.vue?vue&type=style&index=0&id=4ba98eba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba98eba",
  null
  
)

export default component.exports